// extracted by mini-css-extract-plugin
export var bannerHeadline = "r_9";
export var bannerItem = "r_bc";
export var bannerList = "r_bb";
export var bannerWrapper = "r_8";